import http from "../http-common";

class ExaminationScheduleService {
  createExaminationSchedule(data) {
    return http.post(`/api/examination_schedule`, data);
  }
  getExaminationScheduleAll(data) {
    return http.get(`/api/examination_schedule/getExaminationSchedule` + '?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&exam_date=' + data.exam_date + '&faculty_id=' + data.faculty_id + '&course_id=' + data.course_id + '&subject=' + data.subject + '&instructor=' + data.instructor);
  }
  getAll(data) {
    return http.get(`/api/examination_schedule/getAll` + '?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type + '&exam_date=' + data.exam_date + '&faculty_id=' + data.faculty_id + '&course_id=' + data.course_id + '&subject=' + data.subject + '&instructor=' + data.instructor);
  }
  getExaminationSchedules(year, term, exam_type) {
    return http.get(`/api/examination_schedule?year=` + year + '&&term=' + term + '&&exam_type=' + exam_type);
  }
  getExaminationScheduleByFilter(data) {
    return http.get(`/api/examination_schedule/getExaminationScheduleByFilter?year_term_type_id=` + data.year_term_type_id + '&&major_id=' + data.major_id + '&&exam_date=' + data.exam_date + '&&exam_time_from=' + data.exam_time_from + '&&room_id=' + data.room_id + '&&major_desc_id=' + data.major_desc_id);
  }
  getExaminationSchedule(id) {
    return http.get(`/api/examination_schedule/` + id);
  }
  updateExaminationSchedule(id, data) {
    return http.put(`/api/examination_schedule/${id}`, data);
  }
  AssignProctor(year,term,exam_type) {
      return http.get(`/api/examination_schedule/assign-proctor`+`?year=${year}&term=${term}&exam_type=${exam_type}`);
    }
  GeneratePDF(year, term, exam_type) {
    return http.get(`/exportpdfV2` + `?year=${year}&term=${term}&exam_type=${exam_type}`);
  }
deleteExaminationSchedulel(data){
    return http.delete(`/api/examination_schedule`+'?year=' + data.year + '&term=' + data.term + '&exam_type=' + data.exam_type);
  }
}

export default new ExaminationScheduleService();